module.exports = __webpack_public_path__ + "img/sv72.374c96ec.svg";